module.exports = "<div class=visible-collection-view tabindex=0></div>";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/list.hbs
// module id = 210
// module chunks = 0